import styled from 'styled-components';
import { themeGet, getBackgroundColor, getTextColor } from '@magalu/stereo-ui-styles';
import { Facebook, Twitter, Instagram, Pinterest } from '@magalu/stereo-ui-icons';
import Image from '../../../atoms/ResponsiveImage';
export const Container = styled.footer`
  background-color: ${props => getBackgroundColor('luContentPrimary')(props)};
`;
export const Text = styled.p`
  color: ${props => getTextColor('lightest')(props)};
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  text-align: center;
  padding-top: 12px;
`;
export const LinkWrapper = styled.div``;
export const Link = styled.a`
  cursor: pointer;
`;
export const LogosContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  padding: 16px 2em;
`;
export const BlogLuImage = styled(Image)`
  max-width: 109px;
  max-height: 20px;
`;
export const FacebookIcon = styled(Facebook).attrs(props => ({
  color: getBackgroundColor('luContentPrimary')(props)
}))``;
export const TwitterIcon = styled(Twitter).attrs(props => ({
  color: getBackgroundColor('luContentPrimary')(props)
}))``;
export const InstagramIcon = styled(Instagram).attrs(props => ({
  color: getBackgroundColor('luContentPrimary')(props)
}))``;
export const PinterestIcon = styled(Pinterest).attrs(props => ({
  color: getBackgroundColor('luContentPrimary')(props)
}))``;
export const Circle = styled.div`
  background-color: ${props => getBackgroundColor('base')(props)};
  width: 20px;
  height: 20px;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  > svg {
    width: 12px;
  }
`;